module.exports = __webpack_public_path__ + "images/emoji/key.9130ac6528169fd90a6b.png";